import * as React from 'react';
import { Box, TextInput, Switch, Group, Button, Textarea, createStyles, Title, NumberInput, FileInput } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import type { ICategory } from "./types";
import { IMAGE_MIME_TYPE } from "@mantine/dropzone";
import FileUpload from "../../components/file-upload";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";
import { assignFiles } from "../../utils/form";

interface FormValues extends Pick<ICategory, 'code' | 'title' | 'description' | 'order' | 'isFeatured' | 'categoryNumber'> {
    cover: File | null;
}

interface IParams extends Omit<FormValues, 'cover'> {
    cover?: string;
}

const CreateCategory = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            code: '',
            title: '',
            description: '',
            cover: null,
            order: 0,
            isFeatured: false,
            categoryNumber: 0,
        },

        validate: {
            title: isNotEmpty('Нэр оруулна уу'),
            code: isNotEmpty('Код оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const files = await assignFiles({
            cover: values.cover
        }, 'category')
        const params: IParams = {
            ...values,
            ...files
        }

        const { data } = await axios.post<IResponse<any>>(API_ROUTE, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Код"
                            placeholder="Код оруулна уу"
                            {...form.getInputProps('code')}
                        />

                        <TextInput
                            withAsterisk
                            label="Нэр"
                            placeholder="Нэр оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <NumberInput
                            hideControls
                            label="Ангилал дугаар"
                            placeholder="Ангилал дугаар"
                            {...form.getInputProps('categoryNumber')}
                        />

                        <Textarea
                            label="Тайлбар"
                            placeholder="Тайлбар..."
                            {...form.getInputProps('description')}
                        />

                        <FileUpload
                            value={form.values.cover}
                            onChange={(value) => {
                                form.setFieldValue('cover', value);
                            }}
                            label='Ковер зураг'
                            accept={IMAGE_MIME_TYPE}
                        />

                        <NumberInput
                            label="Дараалал"
                            placeholder="Дараалал"
                            {...form.getInputProps('order')}
                        />

                        <Switch
                            label="Онцолсон эсэх"
                            {...form.getInputProps('isFeatured', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateCategory;